export default __webpack_public_path__ + "9565f255210fd067ab56e17544866188.woff2";